import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../stores/userStore';
import ChallengeQuestions from './Profile/components/ChallengeQuestions';

const CompleteRegistration = () => {
	const { user } = useUserStore();
	const navigate = useNavigate();

	const handleSave = () => {
		navigate('/home');
	};

	return (
		<div className="justify-center py-12 page">
			<div className="text-center sm:mx-auto sm:w-full sm:max-w-md">
				<h2>Complete Registration</h2>
				<p className="mt-1 text-sm leading-6 text-gray-600">
					Complete your registration by setting your challenge questions to
					allow for account recovery in case you forget your password.
				</p>
			</div>
			<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-md">
				<ChallengeQuestions user={user} onSave={handleSave} />
			</div>
		</div>
	);
};

export default CompleteRegistration;
